/* global BigInt */
// Currency is carried as integer cents. Parse decimal text without floating point rounding.
export function parseCents(value) {
  if (typeof value !== 'string' || !/^\d+(?:\.\d{1,2})?$/.test(value.trim())) return null;
  const [whole, fraction = ''] = value.trim().split('.');
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
  return cents <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(cents) : null;
}

export const validCents = (value) => Number.isSafeInteger(value) && value >= 0;
export const decimalCents = (value) =>
  validCents(value) ? `${BigInt(value) / 100n}.${String(value % 100).padStart(2, '0')}` : '';
export const usd = (value) =>
  Number.isSafeInteger(value)
    ? `${value < 0 ? '−' : ''}$${(BigInt(Math.abs(value)) / 100n).toLocaleString('en-US')}.${String(Math.abs(value) % 100).padStart(2, '0')}`
    : 'Unavailable';

/** Report totals can exceed safe JS integers. Keep the server's exact decimal string. */
export function cashReportMoney(value) {
  if (typeof value !== 'string' || !/^-?\d+\.\d{2}$/.test(value)) return 'Unavailable';
  const negative = value.startsWith('-'),
    [whole, cents] = value.replace(/^-/, '').split('.');
  return `${negative ? '−' : ''}$${BigInt(whole).toLocaleString('en-US')}.${cents}`;
}

export function affordableItems(balance, rateScaled, unitsPerItem, shipping) {
  if (
    ![balance, rateScaled, unitsPerItem, shipping].every(validCents) ||
    !rateScaled ||
    !unitsPerItem
  )
    return null;
  // Orders require at least one cent of product cost, even when fractional rates round down.
  if (shipping >= balance) return 0;
  // Largest quantity whose whole-line half-up price fits; rounding each item first is incorrect.
  const numerator = (BigInt(balance - shipping) + 1n) * 100n - 51n;
  const count = numerator / (BigInt(rateScaled) * BigInt(unitsPerItem));
  return count <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(count) : null;
}
